import React, { useState } from "react";
import style from "./styles.module.scss";
import Avatar from "../../../../components/Avatar/Avatar";
import Button from "../../../../components/new-button";
import DeleteIcon from "../../../../assets/svg/icons/common/delete";

function NoteItem({ note, onDeletetClick }) {
  


  const handleDeleteClick = () => {
    if (onDeletetClick) {
      onDeletetClick(note.id);
    }
  };

  // Helper function to get display name for the user
  const getDisplayName = () => {
    if (note.who && note.who.trim()) {
      return note.who;
    }
    
    // If no who field, try to use note_owner
    if (note.note_owner) {
      return note.note_owner;
    }
    
    // If it has a user_id but no name
    if (note.user_id) {
      return note.user_id === 1 ? 'Admin' : `User ${note.user_id}`;
    }
    
    return "Anonymous";
  };

  // Helper function to get formatted date
  const getFormattedDate = () => {
    if (note.created_at) {
      try {
        const date = new Date(note.created_at);
        
        // Format as "12 Oct | 10:12 PM"
        const day = date.getDate();
        const monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
        const month = monthNames[date.getMonth()];
        
        let hours = date.getHours();
        const ampm = hours >= 12 ? 'PM' : 'AM';
        hours = hours % 12;
        hours = hours ? hours : 12; // convert 0 to 12
        
        const minutes = date.getMinutes().toString().padStart(2, '0');
        
        return `${day} ${month} | ${hours}:${minutes} ${ampm}`;
      } catch (e) {
        console.error('Error formatting date:', e);
        return 'Recently';
      }
    }
    
    return "";
  };

  // Helper function to get time ago for tooltip
  const getTimeAgo = () => {
    // If created_ago is available from API, use that
    if (note.created_ago) {
      return note.created_ago;
    }
    
    // If no created_ago, calculate a "time ago" value
    if (note.created_at) {
      try {
        const date = new Date(note.created_at);
        const now = new Date();
        const seconds = Math.floor((now - date) / 1000);
        
        if (seconds < 60) return 'Just now';
        
        const minutes = Math.floor(seconds / 60);
        if (minutes < 60) return `${minutes} minute${minutes !== 1 ? 's' : ''} ago`;
        
        const hours = Math.floor(minutes / 60);
        if (hours < 24) return `${hours} hour${hours !== 1 ? 's' : ''} ago`;
        
        const days = Math.floor(hours / 24);
        if (days < 30) return `${days} day${days !== 1 ? 's' : ''} ago`;
        
        const months = Math.floor(days / 30);
        if (months < 12) return `${months} month${months !== 1 ? 's' : ''} ago`;
        
        const years = Math.floor(months / 12);
        return `${years} year${years !== 1 ? 's' : ''} ago`;
      } catch (e) {
        console.error('Error calculating time ago:', e);
        return 'Recently';
      }
    }
    
    return "";
  };


  return (
    <>
      <div className={`${style.note} `}>
        <Avatar />
        <div className={style.content}>
          <div className={style.note_container}>
            <div className={style.header}>
              <div className={style.user}>
                <h6>{getDisplayName()} </h6>
              </div>
              <div className={style.time} title={getTimeAgo()}>
                {getFormattedDate()}
              </div>
            </div>

            <div className={style.text}>
              <p>{note.content}</p>
            </div>
          </div>
        </div>
          <Button
            variant="ghost"
            size="small"
            onClick={handleDeleteClick}
            style={{ marginTop: "-8px" }}
          >
            <DeleteIcon />
          </Button>
      </div>


      
    </>
  );
}

export default NoteItem;
